import React from "react";
import AboutClients from "../components/AboutClients";
import Accordium from "../components/Accordium";
import Join from "../components/Join";


const Faq = () => {
  return (
    <>
      <Accordium />
      <AboutClients />
      <Join />
    </>
  );
};

export default Faq;
